import { Component } from '../component/component';

export class MetadataItem extends Component {

	constructor(item) {
		super();
		this.item = item;
		this.node = this.getNode();
	}

	getTemplate() {
		const name = this.item.name;
		const value = this.item.value + (this.item.unit ? ` ${this.item.unit}` : '');
		let template = /* html */`<div class="flex">
            <div class="dato">${name}</div>
            <div>${value}</div>
        </div>`;
		return template;
	}

}
